import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';
import { useRouter } from 'next/navigation';

import { publicEnv } from '@/lib/env';
import { isGameMakerMatch } from '@/modules/results/helpers';
import { ListResults } from '@/modules/results/match/ListResults';
import MatchHeader from '@/modules/results/match/MatchHeader';
import { MatchPlayers } from '@/modules/results/match/MatchPlayers';
import { H2HStats, Match } from '@/modules/results/types';

interface ResultMatchCardProps {
  match: Match;
  matchH2HData?: H2HStats;
  setOpenMatchUUID: React.Dispatch<React.SetStateAction<string>>;
  pbracketsURL?: string;
}

export const ResultMatchCard = ({
  match,
  matchH2HData,
  setOpenMatchUUID,
  pbracketsURL,
}: ResultMatchCardProps) => {
  const router = useRouter();

  const bracketsURL = `${publicEnv.NEXT_PUBLIC_BRACKETS_URL}/tournaments/${match?.tournament_uuid}/events/${match?.event_uuid}/pools/${match?.pool_id}`;

  return (
    <div
      style={{
        backgroundImage: `url(${getCDNURL(`${publicEnv.NEXT_PUBLIC_IMAGE_CDN_URL}/global/legacy/match-stats.svg`, 1000, 1000)})`,
        backgroundPosition: 'top',
        backgroundSize: 'cover',
      }}
      className='bg-indigo-600 relative flex min-h-[416px] w-full flex-col px-2 py-8 sm:min-h-[484px] sm:px-4'
    >
      <div className='container mx-auto flex justify-between sm:mb-0 mb-2'>
        <button
          onClick={() => router.back()}
          className='ml-0 flex w-[70px] cursor-pointer items-center justify-center gap-1 rounded bg-experiment text-xs text-white sm:ml-4 h-[30px] sm:w-[80px] sm:text-sm'
        >
          <FontAwesomeIcon icon={faArrowLeft} />
          Back
        </button>
        <div className='flex items-center'>
          {match?.match_number !== 0 && !isGameMakerMatch(match) && (
            <a
              href={pbracketsURL || bracketsURL}
              className='ml-0 flex w-[90px] cursor-pointer items-center justify-center gap-1 rounded bg-experiment text-xs text-white sm:ml-4 h-[30px] sm:w-[100px] sm:text-sm'
              aria-label={`Link to view bracket for ${match?.tournament_title}`}
            >
              <p>View Bracket</p>
            </a>
          )}
          <button
            onClick={() => setOpenMatchUUID(match?.match_uuid || '')}
            className='flex w-[104px] cursor-pointer items-center justify-center gap-1 rounded bg-experiment text-xs text-white ml-1 sm:ml-2 h-[30px] sm:w-[160px] sm:text-sm'
          >
            <span className='hidden sm:inline'>Download Match Card</span>
            <span className='inline sm:hidden'>Download Card</span>
          </button>
        </div>
      </div>
      <div className='relative flex flex-col items-center justify-center'>
        <MatchHeader match={match} />
        <div className='mt-1 flex w-full flex-col justify-center sm:flex-row'>
          <div className='flex w-full text-center sm:gap-4 lg:w-1/2'>
            <div className='flex-1'>
              <MatchPlayers match={match} team={1} matchH2HData={matchH2HData} />
            </div>
            <div className='flex'>
              <ListResults match={match} />
            </div>
            <div className='flex-1'>
              <MatchPlayers match={match} team={2} matchH2HData={matchH2HData} />
            </div>
          </div>
        </div>
      </div>
      <div className='flex justify-center'>
        <div className='absolute bottom-2'>
          <div className='mt-3 flex gap-10 text-sm font-bold text-white sm:mt-0'>
            {match?.court_title !== '' && (
              <div>
                <p>Court {match?.court_title}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
